import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Session } from 'src/app/models/session';
import { ApiProviderService } from 'src/app/services/api-provider.service';
import { UserService } from 'src/app/services/user.service';
import { ModalController, ToastController } from '@ionic/angular';
import { ListClientSelectableComponent } from '../../client/list-client-selectable/list-client-selectable.component';
import { ListAddressSelectableComponent } from '../../address/list-address-selectable/list-address-selectable.component';
import { Address } from 'src/app/models/address';
import { formatDate } from '@angular/common';
import { AlreadySessionComponent } from '../../../shared/modals/already-session/already-session.component';
import { User } from 'src/app/micro-services/user/models/user';

@Component({
  selector: 'app-session-form',
  templateUrl: './session-form.component.html',
  styleUrls: ['./session-form.component.scss'],
})
export class SessionFormComponent implements OnInit {

  sessionForm: FormGroup;
  @Input() session: Session;
  @Input() client: User;

  searchUserLiser: User[] = [];

  @Output() sess = new EventEmitter<Session>();

  startDate: string;

  isStartOrEnd = true;
  isCalendarDateStarShow = false;
  isCalendarTimeStarShow = false;
  isCalendarDateEndShow = false;
  isCalendarTimeEndShow = false;
  isModalUserOpen = false;

  title = 'Creation d\'un session';
  todayDate: string;
  todayTime: string;
  today: string;
  startDateChanged: string;
  searchTerm: string;

  selectedClients: User[] = [];
  selectedAddress: Address[] = [];

  constructor(
    private apiProvider: ApiProviderService,
    private userService: UserService,
    public modalCtrl: ModalController,
    private toastController: ToastController,
  ) {

  }

  ngOnInit() {
    this.startDateChanged = formatDate(new Date(), 'yyyy-MM-ddTHH:mm:ss', 'fr-CA');
    this.startDateChanged = formatDate(new Date(), 'yyyy-MM-ddTHH:mm:ss', 'fr-CA');
    this.today = formatDate(new Date(), 'yyyy-MM-ddTHH:mm:ss', 'fr-CA')
    let todayPlusOneH = formatDate(new Date(new Date().getTime() + 60 * 60000), 'yyyy-MM-ddTHH:mm:ss', 'fr-CA')
    this.todayDate = formatDate(new Date(), 'yyyy-MM-ddTHH:mm:ss', 'fr-CA')
    //this.todayTime = formatDate(new Date(), 'HH:mm','fr-CA')

    if (this.session) {
      if (this.session.clients) {
        this.selectedClients = this.session.clients;

      }
      if (this.session.address) {
        this.selectedAddress.push(this.session.address)

      }
      this.sessionForm = new FormGroup(
        {
          Title: new FormControl(this.session.title, [Validators.required]),
          StartDate: new FormControl(this.session.startDate, [Validators.required]),
          EndDate: new FormControl(this.session.endDate, [Validators.required]),
          Clients: new FormControl(this.session.clients),
          Address: new FormControl(this.session.address),
          Color: new FormControl(this.session.color),
          Note: new FormControl(this.session.note)
        }
      );
    } else {
      this.sessionForm = new FormGroup(
        {
          Title: new FormControl('', [Validators.required]),
          StartDate: new FormControl(this.today, [Validators.required]),
          EndDate: new FormControl(todayPlusOneH, [Validators.required]),
          Clients: new FormControl([]),
          Address: new FormControl(undefined),
          Color: new FormControl('blue'),
          Note: new FormControl('')
        }
      );
      if (this.client) {
        const currentClients = this.sessionForm.controls.Clients.value || [];
        currentClients.push(this.client);
        this.sessionForm.controls.Clients.setValue(currentClients);
        this.selectedClients.push(this.client)
      }
    }

  }


  changed(event: any) {

    if (event.detail) {
      if (new Date(event.detail?.value).getTime() >= new Date(new Date(new Date(this.sessionForm.controls.EndDate.value).setMilliseconds(0)).setSeconds(0)).getTime()) {
        this.sessionForm.controls.EndDate.setValue(formatDate(new Date(event.detail?.value).setHours(new Date(event.detail?.value).getHours() + 1), 'yyyy-MM-ddTHH:mm:ss', 'fr-CA'));
      }
      this.startDateChanged = formatDate(event.detail?.value, 'yyyy-MM-ddTHH:mm:ss', 'fr-CA');
      this.startDateChanged = formatDate(event.detail?.value, 'yyyy-MM-ddTHH:mm:ss', 'fr-CA');
    }
  }

  inverse(varToInverse: string) {
    if (varToInverse === 'isCalendarDateStarShow') {
      this.isCalendarTimeEndShow = false;
      this.isCalendarDateEndShow = false;

      this.isCalendarTimeStarShow = false;
      this.isCalendarDateStarShow = !this.isCalendarDateStarShow;
    }
    if (varToInverse === 'isCalendarTimeStarShow') {
      this.isCalendarTimeEndShow = false;
      this.isCalendarDateEndShow = false;

      this.isCalendarDateStarShow = false;
      this.isCalendarTimeStarShow = !this.isCalendarTimeStarShow;
    }

    if (varToInverse === 'isCalendarDateEndShow') {
      this.isCalendarTimeStarShow = false;
      this.isCalendarDateStarShow = false;

      this.isCalendarTimeEndShow = false;
      this.isCalendarDateEndShow = !this.isCalendarDateEndShow;
    }
    if (varToInverse === 'isCalendarTimeEndShow') {
      this.isCalendarTimeStarShow = false;
      this.isCalendarDateStarShow = false;

      this.isCalendarDateEndShow = false;
      this.isCalendarTimeEndShow = !this.isCalendarTimeEndShow;
    }
  }

  async addAddress() {

    const modal = await this.modalCtrl.create({
      component: ListAddressSelectableComponent,
      componentProps: {
        isOneValueSelectable: true
      }
    });
    if (this.sessionForm?.controls.Address.value) {
      modal.componentProps = {
        isOneValueSelectable: true,
        selectedAddresses: [this.sessionForm?.controls.Address.value]
      };

    }

    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      this.sessionForm?.controls.Address.setValue(data[0]);
      this.selectedAddress = data;
    }

  }

  validation() {
    if (this.sessionForm.invalid) {
      return;
    }
    this.session = new Session();
    this.session.coach = this.userService.getUser();
    this.session.startDate = this.sessionForm.controls.startDate.value;
    this.session.endDate = this.sessionForm.controls.endDate.value;

    this.apiProvider.createSession(this.session);
  }

  async openModalAddClient() {
    const modal = await this.modalCtrl.create({
      component: ListClientSelectableComponent,
      componentProps: {
        onlyActifUser: true
      }
    });

    if (this.sessionForm?.controls.Clients.value) {
      modal.componentProps["selectedUsers"] = JSON.parse(JSON.stringify(this.sessionForm?.controls.Clients.value));
    }

    modal.present();

    const { data, role } = await modal.onWillDismiss();
    if (role === 'confirm') {
      this.sessionForm?.controls.Clients.setValue(data);
      this.selectedClients = data;
    }
  }

  cancel() {
    this.modalCtrl.dismiss(null, 'cancel');
  }

  confirm() {
    if (this.sessionForm.invalid && new Date(this.sessionForm.get('StartDate').value).getTime() <= new Date(this.sessionForm.get('EndDate').value).getTime()) {
      this.sessionForm.markAllAsTouched();
      return;
    }

    if (!this.session) {
      this.createSession();

    } else {
      if (this.session.id) {
        this.apiProvider.editSession({ ... this.sessionForm.value, id: this.session.id, AddressId: this.sessionForm.controls.Address.value?.id, CoachId: this.userService.getUser().id }).subscribe(
          (session: Session) => {
            this.modalCtrl.dismiss(session, 'edit');
          },
          (err) => {
            console.log(err);
          });
      } else {
        //Si il n'y a pas d'id c'est que l'on vien d'une creation de session a partir de list session bis
        this.createSession();
      }
    }
  }


  createSession() {

    this.apiProvider.isAlreadySession({ ... this.sessionForm.value, Id: 0, AddressId: this.sessionForm.controls.Address.value?.id, CoachId: this.userService.getUser().id }).subscribe(
      async (sesss: Array<Session>) => {

        if (sesss.length > 0) {
          const modal = await this.modalCtrl.create({
            component: AlreadySessionComponent,
            componentProps: {
              startDate: this.sessionForm.controls.StartDate.value,
              endDate: this.sessionForm.controls.EndDate.value,
              sessionForm: this.sessionForm
            },
          });
          modal.present();

          const { data, role } = await modal.onWillDismiss();

          if (role === 'confirm') {
            this.apiProvider.createSession({ ... this.sessionForm.value, Id: 0, AddressId: this.sessionForm.controls.Address.value?.id, CoachId: this.userService.getUser().id }).subscribe(
              async (session: Session) => {
                const toast = await this.toastController.create({
                  message: 'Session ajoutée avec succès !',
                  duration: 1500,
                  position: "top",
                });

                await toast.present();
                this.modalCtrl.dismiss(session, 'create');
                //this.sess.emit(session);          
              },
              (err) => {
                console.log(err);
              }
            )
          }
        } else {
          this.apiProvider.createSession({ ... this.sessionForm.value, Id: 0, AddressId: this.sessionForm.controls.Address.value?.id, CoachId: this.userService.getUser().id }).subscribe(
            async (session: Session) => {
              const toast = await this.toastController.create({
                message: 'Session ajoutée avec succès !',
                duration: 1500,
                position: "top",
              });

              await toast.present();
              this.modalCtrl.dismiss(session, 'create');
              //this.sess.emit(session);          
            },
            (err) => {
              console.log(err);
            }
          )
        }
      }
    )
  }


}
